import React, { useEffect, useState } from 'react';
import "./PrintBillDesk.scss";
import moment from 'moment';
import { calculateAge } from 'core/utils/date';
import { getInvoiceHistory, getPrintDetails } from 'core/services/api';

function PrintBillDesk({ printRef, invoice, currentCenter, patient }: any) {
  const [newInvoice, setNewInvoice] = useState<any>();
  const [invoiceHistory, setInvoiceHistory] = useState<any>([])

  //Total Taxes
  const totalTaxes = newInvoice?.invoiceItems?.reduce((a: any, item: any) => {
    return a + item?.totalTaxAmount
  }, 0)

  //Calculate Discount Amount
  const calculateDiscountAmount = (cost: any, discountPercentage: any, discountType: any) => {
    if (!cost || !discountPercentage) return 0;
    const costAmount = parseFloat(cost);
    if (discountType === "PERCENTAGE") {
      const discountPercentageValue = parseFloat(discountPercentage) / 100;
      const discountAmount = costAmount * discountPercentageValue;
      return discountAmount.toFixed(2);
    } else if (discountType === "AMOUNT") {
      const discountAmountValue = parseFloat(discountPercentage);
      return discountAmountValue.toFixed(2);
    }
  };

  //Calculate Grand Total
  function calculateGrandTotal(totalAmount: any, discountAmount: any) {
    //Final Amount
    const grandTotal = totalAmount - discountAmount
    return grandTotal?.toFixed(2)
  }

  useEffect(() => {
    if (invoice?.id) {
      getPrintDetails(invoice?.id)
        .then((res) => {
          setNewInvoice(res);
        })
        .catch((err) => {
          console.log(err, "error")
        })
    }
    if (invoice?.id) {
      getInvoiceHistory(invoice?.id)
        .then((res) => {
          setInvoiceHistory(res)
        })
        .catch((error: any) => {
          console.log(error)
        })
    }
  }, [invoice?.id])

  return (
    <div className='print-billdesks-wrapper'
      id="printId"
      ref={printRef}
    >
      <section className='section-wrapper'>
        <div className='heading-1'>{currentCenter?.brandName ? currentCenter?.brandName : `Mumbai Oncocare Centre ${currentCenter?.centerName}`}
        </div>
        <div className='heading-2'>{currentCenter?.companyName ? currentCenter?.companyName : "Cellcure Cancer Centre Private Limited"}</div>
        {totalTaxes > 0 ? <> <div className='heading-2'>Tax Invoice</div></> : <> <div className='heading-2'>Bill Of Supply</div></>}
      </section>

      <section className='section-2'>
        <section className='main-section-2'>
          <div className='subHeading-main'>Name:&nbsp;<span className='subHeading2-main'>{newInvoice?.patientName}</span></div>
          <div className='subHeading-main'>Patient ID:&nbsp;<span className='subHeading2-main'>{newInvoice?.mocPatientId}</span></div>
          <div className='subHeading-main'>Age: &nbsp;<span className='subHeading2-main'> {calculateAge(patient?.dob)}</span></div>
          <div className='subHeading-main'>Gender: &nbsp;<span className='subHeading2-main'>{newInvoice?.gender}</span></div>
          <div className='subHeading-main'>Invoice Id: &nbsp;<span className='subHeading2-main'>{newInvoice?.mocInvoiceId}</span></div>
          <div>
            <div className='subHeading-main'>Patient Category: &nbsp;<span className='subHeading2-main'>{newInvoice?.patientCategory}</span></div>
            <div className='subHeading-main'>Patient SubCategory: &nbsp;<span className='subHeading2-main'>{newInvoice?.subCategory
            }</span></div>
          </div>
          <div className='subHeading-main'>Primary Consultant:&nbsp;<span className='subHeading2-main'>{newInvoice?.primaryConsultantName
          }</span></div>
          <div className='subHeading-main'>Appointment Id:&nbsp;<span className='subHeading2-main'>{newInvoice?.mocAppointmentId
          }</span></div>

          <div className='subHeading-main'>Appointment Type:&nbsp;<span className='subHeading2-main'>{newInvoice?.appointmentType}</span></div>
          {newInvoice?.appointmentType == "IPD" ? <> <div className='subHeading-main'>Bed Type: &nbsp;<span className='subHeading2-main'>  {newInvoice?.bedDetails?.bedName} &nbsp; &nbsp;{newInvoice?.bedDetails?.roomName}
          </span>
          </div></> : <></>}

        </section>
        <section className='main-section-2'>

          <div className='subHeading-main'>GST No:&nbsp; <span className='subHeading2-main'>{newInvoice?.gstNumber}</span>	</div>
          <div className='subHeading-main'>Date:&nbsp;<span className='subHeading2-main'>{moment(newInvoice?.appointmentDate).format(
            "DD-MM-YYYY"
          )}{" "}
          </span>
          </div>
        </section>

      </section>

      <section className="styled-table">
        <div className='table-heading' style={{ marginBottom: '20px' }}>Invoices</div>
        <table className="table">
          <thead>
            <tr>
              <th className='subHeading'>Treatments & Products</th>
              <th className='subHeading'>SAC No</th>
              <th className='subHeading'>Cost</th>
              <th className='subHeading'>Discount</th>
              <th className='subHeading'>Qty</th>
              <th className='subHeading'>CGST</th>
              <th className='subHeading'>IGST</th>
              <th className='subHeading'>SGST</th>
              <th className='subHeading'>Total Tax</th>
              <th className='subHeading'>Exempt</th>
              <th className='subHeading'>Total</th>
            </tr>
          </thead>
          <tbody>
            {newInvoice?.invoiceItems?.map((item: any) => {
              if (item?.archive) {
                return null;
              }
              const cgstTaxes = item?.taxes?.filter((tax: any) => tax?.name === "CGST");
              const sgstTaxes = item?.taxes?.filter((tax: any) => tax?.name === "SGST");
              const igstTaxes = item?.taxes?.filter((tax: any) => tax?.name === "IGST");
              return (
                <tr key={item.id}>
                  <td className='subHeading2'>{item?.treatmentAndDetails}</td>
                  <td className='subHeading2' style={{ textTransform: 'capitalize' }}>{item?.sacNumber}</td>
                  <th className='subHeading2'>{item?.cost}</th>
                  <td className='subHeading2'>{calculateDiscountAmount(item?.cost, item?.discount, item?.discountType)}</td>
                  <td className='subHeading2'>{item?.quantity}</td>
                  <td className='subHeading2'>{cgstTaxes.length > 0 ? cgstTaxes[0]?.amount : "0"}</td>
                  <td className='subHeading2'>{igstTaxes.length > 0 ? igstTaxes[0]?.amount : "0"}</td>
                  <td className='subHeading2'>{sgstTaxes.length > 0 ? sgstTaxes[0]?.amount : "0"}</td>

                  <td className='subHeading2'>{item?.totalTaxAmount}</td>
                  {item?.totalTaxAmount > 0 ? (
                    <td className='subHeading2' style={{ color: "red", fontWeight: '800' }}>Taxable</td>
                  ) : (
                    <td className='subHeading2' style={{ color: "red", fontWeight: '800' }}>Exempt</td>
                  )}
                  <td className='subHeading2'>{item?.charges}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </section >
      <section className='calculation-section'>

        <div className='calc-right'>
          <div className="calc-wrapper">
            <div className="amount-parent">
              <div className='subHeading'>Total Amount</div>
              <div className='subHeading2'>{newInvoice?.totalLineItemCost?.toFixed(2)
              }</div>
              <div className='subHeading2'>INR</div>
            </div>
            <hr />
            <div className="amount-parent">
              <div className='subHeading'>Total Line Item Discount</div>
              <div className='subHeading2'>{newInvoice?.totalLineItemDiscount?.toFixed(2)
              }</div>
              <div className='subHeading2'>INR</div>
            </div>
            <hr />
            <div className="amount-parent">
              <div className='subHeading'>Overall Discount</div>
              <div className='subHeading2'>{newInvoice?.discountAmount?.toFixed(2)
              }</div>
              <div className='subHeading2'>INR</div>
            </div>
            <hr />
            <div className="amount-parent">
              <div className='subHeading'>Grand Total</div>
              <div className='subHeading2'>{calculateGrandTotal(newInvoice?.totalAmount, newInvoice?.discountAmount
              )}</div>
              <div className='subHeading2'>INR</div>
            </div>
            <hr />
            <div className="amount-parent">
              <div className='subHeading'>Amount Received</div>
              <div className='subHeading2'>{newInvoice?.totalAmountPaid?.toFixed(2)

              }</div>
              <div className='subHeading2'>INR</div>
            </div>
            <hr />
            <div className="amount-parent" style={{ paddingBottom: '20px' }}>
              <div className='subHeading'>Balance Remaining</div>
              <div className='subHeading2'>{newInvoice?.pendingAmount?.toFixed(2)}</div>
              <div className='subHeading2'>INR</div>
            </div>

          </div>
        </div>
      </section>
      {
        newInvoice?.payments?.length > 0 ? <>
          <div className="billing-payments-table" style={{ marginBottom: '20px' }}>
            <div className='table-heading'>Payment Details</div>
            <table style={{ paddingTop: '50px' }} className="styled-table" id="tablePreview">
              <thead style={{ backgroundColor: "#E1E3EF" }}>

                <tr>
                  <th className='subHeading'>Receipt Id</th>
                  <th className='subHeading'>Mode of Payment</th>
                  <th className='subHeading'>Transaction Amount</th>
                  <th className='subHeading'>Transaction Date & Time</th>
                  <th className='subHeading'>Remarks</th>
                </tr>
              </thead>

              {invoiceHistory?.paymentHistory?.map((val: any) => {
                return (
                  <>
                    <tbody>
                      <tr>
                        <td className='subHeading2'>{val?.mocReceiptId}</td>
                        <td className='subHeading2'>{val?.modeOfPayment}</td>
                        <td className='subHeading2' style={{ textAlign: "left" }}>
                          {val?.transactionAmount?.toFixed(2)}
                        </td>
                        <td className='subHeading2'>
                          {moment(val?.transactionDateTime).format(
                            "DD-MM-YYYY"
                          )}{" "}
                          &nbsp; &nbsp;
                          {moment(val?.transactionDateTime).format(
                            "h:mm:ss a"
                          )}{" "}
                        </td>
                        <td className='subHeading2'>{val?.remarks}</td>
                      </tr>
                    </tbody>
                  </>
                )
              })}
            </table>
          </div></> : <></>
      }
    </div >
  )
}

export default PrintBillDesk